import { Component } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDialogContent } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'app-system-capabilities-icon-legend',
	templateUrl: './system-capabilities-icon-legend.component.html',
	styleUrls: ['./system-capabilities-icon-legend.component.scss'],
	imports: [CdkScrollable, MatDialogContent, MatIcon],
})
export class SystemCapabilitiesIconLegendComponent {
	constructor() {}
}
